import { combineEpics } from 'redux-observable';
import { omsAuthentication } from '@src/app/login/oms/epics';
import { acctPostalCodeLoginInitiate } from '@src/app/login/weak/accountpostalcode/epics';
import { emailPostalCodeLoginInitiate } from '@src/app/login/weak/emailpostalcode/epics';
import { nameAddressLoginInitiate } from '@src/app/login/weak/nameaddress/epics';
import {
  getUnauthIdentityId,
  doUnauthLookup,
  doAuthLookup,
  fetchCustomer,
  findSecuredUserEpic
} from '@src/app/login/weak/epics';
import { configEpic } from '@src/app/main/epics';
import { clearAWSCreds } from '@src/app/header/epics';

export const epics = combineEpics(
  omsAuthentication,
  configEpic,
  acctPostalCodeLoginInitiate,
  getUnauthIdentityId,
  doUnauthLookup,
  doAuthLookup,
  fetchCustomer,
  clearAWSCreds,
  emailPostalCodeLoginInitiate,
  nameAddressLoginInitiate,
  findSecuredUserEpic,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/login/epics.ts